<div class="icon-ok-check" *ngIf="isMulti && isActive"></div>
<ng-content></ng-content>
